import { I18n } from "react-redux-i18n";
import { FilterStatus, FilterStatusOption } from "../types/filterStatusValue";

export const getStatusFilterOptions = (): FilterStatusOption[] => {
  return [
    { label: I18n.t("allTheTime"), value: FilterStatus.ALL },
    { label: I18n.t("beenFinished"), value: FilterStatus.FINISHED },
    { label: I18n.t("notFinished"), value: FilterStatus.ACTIVE },
  ] as FilterStatusOption[];
};
